import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import FormControlLabel from '@mui/material/FormControlLabel';
import { get } from '../api/api';
import { formatData } from '../utils/formatData';
import Chip from '@mui/material/Chip';
import { isIsoDate } from '../utils/isIsoDate';
import { config } from '../configs/app.config';
import dayjs from 'dayjs';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import AppBar from '@mui/material/AppBar';
import { camel2title } from '../utils/stringUtils';
import Skeleton from '@mui/material/Skeleton';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import IconButton from '@mui/material/IconButton';
import DateTimePicker from '@mui/lab/DateTimePicker';
import Divider from '@mui/material/Divider';
import { Parser } from 'json2csv';
import Tooltip from '@mui/material/Tooltip';
import { Button, MenuItem, Modal, TableSortLabel } from '@mui/material';
import SingleItemBox from './SingleItemBox';
import NewItemBox from './NewItemBox';
import { withRouter, useLocation } from 'react-router-dom';
import axios from 'axios';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { additionalData } from '../configs/additional-data';
import { cacheEnums } from '../utils/cache';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import DarkUnica from 'highcharts/themes/dark-unica';
import CloseIcon from '@mui/icons-material/Close';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { resourcesName, movementsTransactionStats } from '../configs/app.config';
import { formatterDate } from '../utils/formatter';

DarkUnica(Highcharts);
Highcharts.setOptions({
  colors: ['#ED4647', '#F7AC2D', '#FF7A7A', '#3FC715', '#24CBE5', '#64E572', '#FF9655', '#FFF263', '#6AF9C4']
});
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

let aggregatedData = null;

function getLocationQuery(location) {
  let locationQuery = null;
  if (location.search) {
    locationQuery = {};
    location.search
      .replace('?', '')
      .split('&')
      .forEach((item) => {
        const [key, value] = item.split('=');
        locationQuery[key] = value;
      });
  }

  //locationQuery = setCreatedAfterDate(locationQuery)
  return locationQuery;
}

function DataTable(props) {
  const resourceName = props.resource?.name;
  let rowsPerPageOptions = config.rowsPerPage;

  let rowsPerPageSelected = rowsPerPageOptions[0];

  const [data, setData] = React.useState([]);
  const [originalData, setOriginalData] = React.useState([]);
  const [dataCount, setDataCount] = React.useState(0);

  const [loading, setLoading] = React.useState(true);
  const [view, setView] = React.useState('Table');

  const defaultQuery = {
    limit: rowsPerPageSelected,
    page: 0,
  };

  if (props.resource?.sort)
    defaultQuery.sort =
      props.resource?.sort[0] === 'createdAt' || props.resource?.sort[0] === 'date'
        ? `-${props.resource?.sort[0]}`
        : props.resource?.sort[0];

  const [query, setQuery] = React.useState(defaultQuery);

  const determineDensePadding = () => {
    if (!localStorage.densePadding) localStorage.setItem('densePadding', true);
    return localStorage.densePadding;
  };

  const [densePadding, setPadding] = React.useState(determineDensePadding());

  const [itemModalOpen, setItemModalOpen] = React.useState(false);
  const [modalItem, setModalItem] = React.useState(null);

  const [newItemModalOpen, setNewItemModalOpen] = React.useState(false);

  let [enumFilters, setEnumFilters] = React.useState(null);

  const additionalTableData = additionalData[props.resource.name]
    ?.additionalTable
    ? additionalData[props.resource.name].additionalTable(originalData)
    : null;

  if ((resourceName === resourcesName.transactionStat || resourceName === resourcesName.transactionStatPerAsset) && enumFilters) {
    enumFilters.movement = movementsTransactionStats;
  }

  const handleChangePage = (event, newPage) => {
    setQuery({ ...query, page: Number(newPage) || 0 });
    handleSearch({ ...query, page: Number(newPage) || 0 });
  };

  const handleChangeRowsPerPage = (event) => {
    rowsPerPageSelected = parseInt(event.target.value, 10);
    handleSearch({ ...query, limit: rowsPerPageSelected, page: 0 });
  };

  const handleChangeView = (event, newPage) => {
    const newView = event.target.value;
    setView(newView);
    // setQuery({ ...query, page: Number(newPage) || 0 });
    // handleSearch({ ...query, page: Number(newPage) || 0 });
  };

  const handleItemModalOpenById = (name, id) => {
    setItemModalOpen(true);
    setModalItem({ id, name });
  };

  const handleItemModalOpen = (item) => {
    setItemModalOpen(true);
    setModalItem({ object: aggregatedData.rows[item.date].rows });
  };

  const handleItemModalClose = () => {
    setItemModalOpen(false);
    setModalItem(null);
  };

  // const handleNewItemModalOpen = () => {
  //   setNewItemModalOpen(true);
  //   //setModalItem(null);
  // };

  const handleNewItemModalClose = () => {
    setNewItemModalOpen(false);
    //setModalItem(null);
  };

  const handleSort = (key) => {
    let newQuery = { ...query };
    if (query.sort === key || query.sort === `-${key}`) {
      if (query.sort.includes('-')) {
        newQuery = { ...query, sort: query.sort.replace('-', '') };
      } else {
        newQuery = { ...query, sort: `-${query.sort}` };
      }
    } else {
      newQuery = { ...query, sort: key };
    }
    handleSearch(newQuery);
  };

  const setDateAfterDate = (q) => {
    const newQuery = { ...q };
    let dateAfter = ''
    if (props.resource.maxDays) {
      if (!newQuery.dateBefore) {
        if (!newQuery.dateAfter)
          dateAfter = dayjs().subtract(props.resource.maxDays, 'day').set('hour', 0).set('minute', 0).set('second', 0).toISOString();
        else {
          const minDay = dayjs().subtract(props.resource.maxDays, 'day').set('hour', 0).set('minute', 0).set('second', 0);
          dateAfter = minDay.isAfter(dayjs(newQuery.dateAfter)) ? minDay.toISOString() : dayjs(newQuery.dateAfter).toISOString();
        }
      }
      else if (newQuery.dateAfter) {
        const minDay = dayjs(newQuery.dateBefore).subtract(props.resource.maxDays, 'day').set('hour', 0).set('minute', 0).set('second', 0);
        dateAfter = minDay.isAfter(dayjs(newQuery.dateAfter)) ? minDay.toISOString() : dayjs(newQuery.dateAfter).toISOString();
      }
      else
        dateAfter = dayjs(newQuery.dateBefore).subtract(props.resource.maxDays, 'day').set('hour', 0).set('minute', 0).set('second', 0).toISOString();

      newQuery.dateAfter = dateAfter;
    }
    return newQuery
  }

  const downloadAllPages = () => {
    const locationQuery = { ...query, limit: 5000, page: 0 }
    if (!enumFilters) {
      cacheEnums(props.auth.token).then((res) => {
        if (res) {
          setEnumFilters(res);
        }
      });
    }
    setLoading(true);
    const parseLinkIds = (link, targetQuery) => {
      let newLink = link;
      const ids = Object.keys(targetQuery).filter((item) => /Id$/g.test(item));
      ids.forEach(
        (id) => {
          if (targetQuery[id] !== null && targetQuery[id] !== undefined && targetQuery[id] !== '')
            newLink = newLink.replace(`:${id}`, targetQuery[id])
        },
      );

      // if (targetQuery?.id) newLink = `${newLink}/${targetQuery.id}`;
      return newLink.replace(/:\w*Id/g, '*');
    };
    get(
      parseLinkIds(props.resource.link, locationQuery || query),
      constructStringQuery({
        ...(locationQuery || query),
        page: parseInt((locationQuery || query).page) + 1,
      }, 1),
      {
        token: props.auth.token,
      },
    )
      .then((res) => {
        if (res && res.data) {
          const dataDownload = formatData(res.data, props)
          downloadCsv(dataDownload);
        }
        else {
        }
        setLoading(false);
      })
      .catch((err) => {
        const objError = JSON.parse(JSON.stringify(err));
        if (objError.status && objError.status !== 500) {
          handleSetData([]);
          props.history.push({
            pathname: props.resource.name,
            search: constructStringQuery(locationQuery || query, 2),
          });
          setDataCount(0);
          setQuery(locationQuery || query);
        }
        else {
          handleSetData([]);
          setDataCount(0);
          console.error(objError)
        }
        setLoading(false);
      });
  };

  const downloadCsv = (data) => {
    const today = dayjs(Date.now()).toISOString();
    const csv = new Parser().parse(data);
    const element = document.createElement('a');
    const file = new Blob([csv], { type: 'text/csv' });
    element.href = URL.createObjectURL(file);
    element.download = `${props.resource.name}-${today}.csv`;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  const getTableHeaders = (cols, data, resource) => {
    if (data.length) {
      const keys = cols.map((col) => { return typeof (col) === 'object' ? col.name : col });
      return keys.map((key) => (
        <TableCell
          key={key}
          align='left'
          sx={{ cursor: 'pointer' }}
          onClick={() => {
            if (resource.sort?.includes(key)) {
              handleSort(key);
            }
          }}
        >
          {resource.sort?.includes(key) && (
            <TableSortLabel
              active={query.sort === key || query.sort === `-${key}`}
              direction={
                query.sort === key
                  ? 'asc'
                  : query.sort === `-${key}`
                    ? 'desc'
                    : ''
              }
              sx={{
                display:
                  query.sort === key || query.sort === `-${key}`
                    ? 'inline'
                    : 'none',
              }}
              onClick={() => handleSort(key)}
            ></TableSortLabel>
          )}
          {resource.sort?.includes(key) &&
            !(query.sort === key || query.sort === `-${key}`) && (
              <ArrowUpwardIcon
                sx={{
                  opacity: '20%',
                  fontSize: 20,
                }}
              />
            )}
          <strong>{camel2title(key.replace('.', ' '))}</strong>
        </TableCell>
      ));
    }
  };

  const parseRow = (col, value, item) => {
    const formatter = typeof (col) === 'object' ? col.formatter : null;

    if (formatter && typeof (formatter.fn) === 'function')
      return formatter.fn(value, formatter.parameters);

    const key = typeof (col) === 'object' ? col.name : col;

    if (value === null || value === undefined) return <Chip label='N/A' />;

    if (isIsoDate(value)) return dayjs(value).toISOString();

    // if (key.includes('symbol')) return <Chip color='primary' variant='outlined' label={value} />;
    if (key === 'status' || key === 'state') {
      if (value === 'approved' || value === 'sent')
        return <Chip color='success' variant='outlined' label={value} />;

      else if (value.toString().startsWith('pending'))
        return (
          <Chip
            color='primary'
            variant='outlined'
            style={{ color: '#999927', borderColor: '#999927' }}
            label={value}
          />
        );

      else if (value.toString().startsWith('rejected') || value.toString().startsWith('op-rejected') || value.toString().startsWith('client-rejected') || value.toString().startsWith('expired'))
        return (
          <Chip
            color='primary'
            variant='outlined'
            style={{ color: '#99272A', borderColor: '#99272A' }}
            label={value}
          />
        );

      else if (value.toString().startsWith('sent') || value.toString().startsWith('approved'))
        return (
          <Chip
            color='primary'
            variant='outlined'
            style={{ color: '#99272A', borderColor: '#99272A' }}
            label={value}
          />
        );

      else if (value === 'frozen')
        return (
          <Chip
            color='primary'
            variant='outlined'
            style={{ color: '#276799', borderColor: '#276799' }}
            label={value}
          />
        );

      else
        return (
          <Chip
            color='primary'
            variant='outlined'
            style={{ color: '#FFFFFF', borderColor: '#FFFFFF' }}
            label={value}
          />
        );
    }
    if (/id$/i.test(key))
      return (
        <Button onClick={() => handleItemModalOpenById(key, value)} style={{ textTransform: 'none' }}>{value}</Button>
      );

    if (/options$/i.test(key))
      return (
        <Button onClick={() => handleItemModalOpen(item)} style={{ textTransform: 'none' }}>{value}</Button>
      );

    return value.toString();
  };

  // const handleChangeDense = (event) => {
  //   setDensePadding(event.target.checked);
  // };

  const getFilter = (filterName) => {
    if (!enumFilters) return;

    let parsedFilterName = filterName;
    if (filterName !== 'otcStatus') {
      const split = filterName.replace(/([A-Z])/, '.$1').split('.');
      parsedFilterName =
        split[split.length - 1]?.toLowerCase() || filterName;
    }

    const filters = (enumFilters[parsedFilterName] || enumFilters[filterName]);
    return filters ? filters.sort() : filters;
  };

  const constructStringQuery = (targetQueryObject, index) => {
    let stringQuery = '';
    Object.entries(targetQueryObject).forEach(([key, value]) => {
      if (value === null || value === undefined || value === '') return;
      let newValue = value;
      if (value instanceof Date) {
        newValue = formatterDate(value);
      }
      if (key === 'page') {
        newValue = Number(newValue) || 0;
      }

      stringQuery += `${key}=${newValue}&`;
    });

    if ((resourceName === resourcesName.transactionStat || resourceName === resourcesName.transactionStatPerAsset) && !stringQuery.includes('movement')) {
      stringQuery += `movement=${movementsTransactionStats}`;
    } else {
      stringQuery = stringQuery.slice(0, -1);
    }

    return stringQuery;
  };

  React.useLayoutEffect(() => {
    localStorage.densePadding && localStorage.densePadding === 'false'
      ? setPadding(false)
      : setPadding(true);
  }, []);

  const handleResetFilters = (locationQuery) => {
    handleSearch(defaultQuery);
  };

  const handleSetData = (dataToSet) => {
    let newData = {};
    newData = formatData(dataToSet, props);
    setOriginalData(newData);

    if (props.resource.isAggregateStats) {
      aggregatedData = props.resource.aggregateFunction(newData);
      newData = aggregatedData.data;
    }

    setData(newData);
  };

  const handleSearch = (locationQuery) => {

    if (locationQuery && "otcStatus" in locationQuery) {
      locationQuery.status = locationQuery.otcStatus;
      delete locationQuery.otcStatus;
    }

    if (props.resource.isAggregateStats)
      locationQuery = { ...locationQuery, limit: 10000, page: 0 }

    if (!enumFilters) {
      cacheEnums(props.auth.token).then((res) => {
        if (res) {
          setEnumFilters(res);
        }
      });
    }

    setLoading(true);

    const localQuery = setDateAfterDate(locationQuery || query);
    const parseLinkIds = (link, targetQuery) => {
      let newLink = link;
      const ids = Object.keys(targetQuery).filter((item) => /Id$/g.test(item));
      ids.forEach(
        (id) => {
          if (targetQuery[id] !== null && targetQuery[id] !== undefined && targetQuery[id] !== '')
            newLink = newLink.replace(`:${id}`, targetQuery[id])
        },
      );
      // if (targetQuery?.id) newLink = `${newLink}/${targetQuery.id}`;
      return newLink.replace(/:\w*Id/g, '*');
    };
    get(
      parseLinkIds(props.resource.link, localQuery),
      constructStringQuery({
        ...localQuery,
        page: parseInt((localQuery).page) + 1,
      }, 1),
      {
        token: props.auth.token,
      },
    )
      .then((res) => {
        if (res && res.data) {
          handleSetData(res.data);
          props.history.push({
            pathname: props.resource.name,
            search: constructStringQuery(localQuery, 2),
          });
          setDataCount(res.count);
          setQuery(localQuery);
        }
        else {
          handleSetData([]);
          setDataCount(0);
        }
        setLoading(false);
      })
      .catch((err) => {
        const objError = JSON.parse(JSON.stringify(err));
        if (objError.status && objError.status !== 500) {
          handleSetData([]);
          props.history.push({
            pathname: props.resource.name,
            search: constructStringQuery(localQuery, 2),
          });
          setDataCount(0);
          setQuery(localQuery);
        }
        else {
          handleSetData([]);
          setDataCount(0);
          console.error(objError)
          // props.setAlert(err.message)
        }
        setLoading(false);
      });
  };

  const location = useLocation();
  React.useEffect(() => {
    let locationQuery = getLocationQuery(location);
    const source = axios.CancelToken.source();
    handleSearch(locationQuery);
    return () => {
      source.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderChart = (resource, data) => {
    if (
      additionalData[props.resource.name] &&
      additionalData[props.resource.name].chart
    ) {
      const chartData = additionalData[props.resource.name].chart(data);
      return (
        <Box style={{ margin: '1em' }}>
          <HighchartsReact
            highcharts={Highcharts}
            options={chartData.options}
          />
        </Box>
      );
    } else return null;
  };
  const renderTable = (cols, dataToRender, mainTable = true) => {
    return (
      <Box>
        <TableContainer component={Paper}>
          <Table
            sx={{ minWidth: 700 }}
            aria-label={props.resource.name}
            size={densePadding ? 'small' : 'medium'}
          >
            <TableHead>
              <TableRow>
                {getTableHeaders(cols, dataToRender, props.resource)}
              </TableRow>
            </TableHead>
            <TableBody>
              {mainTable && loading && (
                <Box style={{ width: '90vw' }}>
                  <Skeleton animation='wave' height={50} />
                  <Skeleton animation='wave' height={50} />
                  <Skeleton animation='wave' height={50} />
                  <Skeleton animation='wave' height={50} />
                  <Skeleton animation='wave' height={50} />
                </Box>
              )}
              {mainTable && !loading && !dataToRender.length && (
                <Typography variant='h6' noWrap component='div'>
                  No results
                </Typography>
              )}
              {data.length > 0 &&
                !loading &&
                dataToRender.map((item) => {
                  return (
                    <TableRow hover key={item.id || item.name}>
                      {cols.map((col) => (
                        <StyledTableCell align='left'>
                          {parseRow(col, item[typeof (col) === 'object' ? col.name : col], item)}
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <AppBar position='static'>
        <Toolbar style={{ backgroundColor: '#121212' }}>
          <Typography variant='h4' component='div'>
            {props.resource.title
              ? props.resource.title
              : `${camel2title(props.resource.name)}s`}
          </Typography>
        </Toolbar>
        <Typography variant='caption text' sx={{ textAlign: 'left', backgroundColor: '#1e1e1e', paddingLeft: '2em' }}>
          {localStorage.getItem('baseUrl')}
        </Typography>
      </AppBar>
      <Toolbar
        position='static'
        style={{ paddingBottom: '10px', paddingTop: '10px' }}
      >
        {props.resource.filters?.length ? (
          <Box style={{ marginRight: 'auto', display: 'flex' }}>
            {props.resource.filters.map((filterName) => {
              if (filterName === 'createdAt') {
                return (
                  <Box
                    sx={{ marginLeft: 1 }}
                    style={{ marginRight: 'auto', display: 'flex' }}
                  >
                    <DateTimePicker
                      label='Created After'
                      inputFormat="yyyy/MM/dd hh:mm a"
                      value={query?.createdAfter || null}
                      onChange={(newValue) => {
                        setQuery({ ...query, createdAfter: newValue });
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                    <DateTimePicker
                      label='Created Before'
                      inputFormat="yyyy/MM/dd hh:mm a"
                      value={query?.createdBefore || null}
                      onChange={(newValue) => {
                        setQuery({ ...query, createdBefore: newValue });
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Box>
                );
              }
              else if (filterName === 'date') {
                return (
                  <Box
                    sx={{ marginLeft: 1 }}
                    style={{ marginRight: 'auto', display: 'flex' }}
                  >
                    <DateTimePicker
                      label='Date After'
                      inputFormat="yyyy/MM/dd hh:mm a"
                      value={query?.dateAfter || null}
                      onChange={(newValue) => {
                        setQuery({ ...query, dateAfter: newValue });
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                    <DateTimePicker
                      label='Date Before'
                      inputFormat="yyyy/MM/dd hh:mm a"
                      value={query?.dateBefore || null}
                      onChange={(newValue) => {
                        setQuery({ ...query, dateBefore: newValue });
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Box>
                );
              }
              else if (filterName?.type === 'select') {
                return (
                  <TextField
                    id='outlined-basic'
                    label={camel2title(filterName.label)}
                    select='true'
                    variant='outlined'
                    sx={{ marginRight: 1, width: 150 }}
                    value={query[filterName.queryParameter] || ''}
                    onChange={(newValue) => {
                      setQuery({
                        ...query,
                        [filterName.queryParameter]: newValue.target.value || '',
                      });
                      if (!newValue.target.value) {
                        delete query[filterName.queryParameter];
                      }
                    }}
                  >
                    {filterName.options().map((opt) => {
                      return (
                        <MenuItem key={opt.key} value={opt.value}>
                          {opt.text}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                );
              }
              return (
                <TextField
                  id='outlined-basic'
                  label={camel2title(filterName)}
                  select={!!getFilter(filterName)}
                  variant='outlined'
                  sx={{ marginRight: 1, width: 150 }}
                  value={query[filterName] || ''}
                  onChange={(newValue) => {
                    setQuery({
                      ...query,
                      [filterName]: newValue.target.value || '',
                    });
                    if (!newValue.target.value) {
                      delete query[filterName];
                    }
                  }}
                >
                  {getFilter(filterName) &&
                    getFilter(filterName).map((en) => {
                      return (
                        <MenuItem key={en} value={en}>
                          {en}
                        </MenuItem>
                      );
                    })}
                </TextField>
              );
            })}
            <IconButton
              type='submit'
              sx={{ p: '10px', marginLeft: 1, color: '#FF8325' }}
              aria-label='search'
              onClick={(_newValue) => {
                handleSearch({ ...query, page: 0 });
              }}
            >
              <SearchIcon />
            </IconButton>
            <IconButton
              type='submit'
              sx={{ marginLeft: 1 }}
              aria-label='reset'
              onClick={(_newValue) => {
                handleResetFilters();
              }}
            >
              <RotateLeftIcon />
            </IconButton>
          </Box>


        ) : (
          ''
        )}
      </Toolbar>

      <Typography style={{ display: props.resource.filtersNote ? 'block' : 'none' }} variant='caption text' sx={{ textAlign: 'left', backgroundColor: '#1e1e1e', paddingLeft: '2em', fontStyle: 'italic', fontSize: 'smaller' }}>
        *{props.resource.filtersNote}
      </Typography>
      <Divider />
      <Box sx={{ display: additionalTableData == null ? 'none' : 'block', marginBottom: 4, marginTop: 2 }} >
        <Typography variant='subtitle1' component='div' sx={{ visible: additionalTableData?.title !== undefined, fontStyle: 'italic' }}>
          {additionalTableData?.title}
        </Typography>
        {additionalTableData?.data.length &&
          renderTable(
            Object.keys(additionalTableData.data[0]),
            additionalTableData.data,
            false,
          )}
      </Box>
      <Toolbar style={{ marginBottom: '10px' }}>
        <FormControl component='fieldset'>
          <RadioGroup
            row
            aria-label='view'
            name='row-radio-buttons-group'
            onChange={handleChangeView}
          >
            {(props.resource.views ? props.resource.views : ['Table']).map(
              (v, index) => (
                <FormControlLabel
                  value={v}
                  control={<Radio />}
                  label={v}
                  checked={view === v}
                />
              ),
            )}
          </RadioGroup>
        </FormControl>
        <Tooltip
          title='Download current page as CSV'
          style={{
            display: view === 'Table' ? 'inline-block' : 'none',
          }}
        >
          <IconButton
            sx={{
              color: 'white',
            }}
            aria-label='download'
            onClick={() => {
              downloadCsv(data);
            }}
          >
            <InsertDriveFileIcon />
          </IconButton>
        </Tooltip>
        <Tooltip
          title='Download all pages as CSV (limited to max. 5000 rows)'
          style={{
            marginRight: '1em',
            display: view === 'Table' ? 'inline-block' : 'none',
          }}
        >
          <IconButton
            sx={{
              color: 'white'
            }}
            style={{ display: props.resource.isAggregateStats ? 'none' : 'flex' }}
            aria-label='download'
            onClick={() => {
              downloadAllPages();
            }}
          >
            <FileCopyIcon />
          </IconButton>
        </Tooltip>
        <Box style={{ marginLeft: 'auto', display: props.resource.isAggregateStats ? 'none' : 'flex' }}>
          <TablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            component='div'
            count={dataCount ?? data.length}
            rowsPerPage={!props.resource.isAggregateStats ? Number(query.limit) : 25}
            page={Number(query.page)}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      </Toolbar>

      {view === 'Table' ? renderTable(props.resource.includeCols, data) : ''}
      {view === 'Chart' ? renderChart(props.resource, originalData) : ''}

      <Toolbar style={{ marginBottom: '10px' }}>
        <Box style={{ marginLeft: 'auto', display: props.resource.isAggregateStats ? 'none' : 'flex' }}>
          <TablePagination
            rowsPerPageOptions={rowsPerPageOptions}
            component='div'
            count={dataCount ?? data.length}
            rowsPerPage={!props.resource.isAggregateStats ? Number(query.limit) : 25}
            page={Number(query.page)}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      </Toolbar>
      <Modal
        open={itemModalOpen}
        disableBackdropClick
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            // width: 400,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 16,
            p: 4,
            maxHeight: '100%',
            overflowY: 'auto',
            minWidth: '30%',
            paddingTop: 5
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleItemModalClose}
            sx={{
              position: 'absolute',
              right: 5,
              top: 5,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>

          <SingleItemBox
            item={modalItem}
            resource={props.resource}
            auth={props.auth}
            setAlert={props.setAlert}
          />
        </Box>
      </Modal>
      <Modal
        open={newItemModalOpen}
        disableBackdropClick
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            // width: 400,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            maxHeight: '100%',
            overflowY: 'auto',
            minWidth: '30%'
          }}
        >

          <IconButton
            aria-label="close"
            onClick={handleNewItemModalClose}
            sx={{
              position: 'absolute',
              right: 5,
              top: 5,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>

          <NewItemBox
            item={modalItem}
            resource={props.resource}
            auth={props.auth}
            setAlert={props.setAlert}
          />
        </Box>
      </Modal>
    </Paper>
  );
}

export default withRouter(DataTable);
